import React, { FunctionComponent, useCallback } from "react";
import { Tabs as AntTabs } from "antd";
import { colors, ConfigProvider } from "../ConfigProvider/ConfigProvider";

const Tabs: FunctionComponent<TabsProps> = ({
  tabs,
  defaultTabValue,
  onTabChange,
}) => {
  const handleTabChange = useCallback(
    (key: string) => {
      const tab = tabs.find((x) => x.key === key);
      onTabChange(tab!);
    },
    [tabs, onTabChange],
  );

  return (
    <ConfigProvider
      type="client"
      themeConfigOverride={{
        components: {
          Tabs: {
            itemHoverColor: colors.primary60,
            itemSelectedColor: colors.primary60,
            itemColor: colors.black,
            titleFontSize: 14,
            inkBarColor: colors.primary60,
            horizontalItemPadding: "8px 0",
          },
        },
      }}>
      <AntTabs
        items={tabs}
        defaultActiveKey={defaultTabValue}
        onChange={handleTabChange}
      />
    </ConfigProvider>
  );
};

export interface TabsProps {
  tabs: Array<Tab>;
  defaultTabValue: string;
  onTabChange: (tab: Tab) => void;
}

interface Tab {
  /**
   * Tab label.
   */
  label: string;
  /**
   * Tab value.
   */
  key: string;
  /**
   * Tabs test id.
   */
  buttonTestID?: string;
}

export { Tabs, Tab };
